<template>
    <a
        v-if="domType === 'a'"
        class="pt-link"
        :class="[
            'pt-link--size-' + size,
            { 'pt-link--underline': underline },
            'pt-link--type-' + type,
            'pt-link--theme-' + theme + '--type-' + type,
        ]"
        :href="href"
        :target="target"
    >
        <slot></slot>
    </a>

    <button
        v-else-if="domType === 'btn'"
        class="pt-link"
        :class="[
            'pt-link--size-' + size,
            'pt-link--theme-' + theme + '--type-' + type,
            { 'pt-link--underline': underline },
        ]"
        @click="handleDivClick"
    >
        <slot></slot>
    </button>

    <div
        v-else
        class="pt-link"
        @click="handleClick"
        :class="[
            'pt-link--size-' + size,
            'pt-link--theme-' + theme + '--type-' + type,
            { 'pt-link--underline': underline },
        ]"
    >
        <slot></slot>
    </div>
</template>

<script lang="ts">
import { defineComponent, toRefs } from 'vue';
enum theme {
    'white',
    'dark',
}
enum domType {
    'btn',
    'a',
    'div',
}
enum Size {
    'small',
    'default',
    'medium',
    'big',
    'large',
    'xlarge',
}
enum type {
    'default',
    'primary',
    'dark',
    'whiteness',
}
interface Props {
    target?: String;
    domType?: domType;
    href?: String;
    size?: Size;
    type?: type;
    underline?: Boolean;
    theme?: theme;
}
const props = {
    target: {
        type: String,
        default: '_self',
    },
    domType: {
        type: String,
        default: 'div',
    },
    href: {
        type: String,
    },
    size: {
        type: String,
        default: 'default',
    },
    type: {
        type: String,
        default: 'default',
    },
    underline: {
        type: Boolean,
        default: false,
    },
    theme: {
        type: String,
        default: 'white',
    },
};
export default defineComponent({
    name: 'PtLink',
    props,
    setup(props: Props, { emit }) {
        const handleClick = () => {
            emit('back');
        };
        const handleDivClick = () => {
            emit('click');
        };
        const state = toRefs(props);
        return {
            handleClick,
            handleDivClick,
            ...state,
        };
    },
});
</script>

<style lang="scss" src="../style/link.scss"></style>
